import { render, staticRenderFns } from "./Viewcategory.vue?vue&type=template&id=2d1d0d1d&"
import script from "./Viewcategory.vue?vue&type=script&lang=js&"
export * from "./Viewcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports